import { render, staticRenderFns } from "./newAnnounce.vue?vue&type=template&id=1b26b77d&scoped=true&"
import script from "./newAnnounce.vue?vue&type=script&lang=js&"
export * from "./newAnnounce.vue?vue&type=script&lang=js&"
import style0 from "./newAnnounce.vue?vue&type=style&index=0&id=1b26b77d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b26b77d",
  null
  
)

export default component.exports